import { useContext, useEffect, useRef, useState } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function usePromptWithModal(
  when,
  message = "Are you sure you want to leave?",
) {
  const navigator = useContext(NavigationContext).navigator;
  const [showModal, setShowModal] = useState(false);
  const nextArgsRef = useRef(null);
  const originalPushRef = useRef(navigator.push);

  const proceed = () => {
    if (nextArgsRef.current) {
      navigator.push = originalPushRef.current;
      navigator.push(...nextArgsRef.current);
      nextArgsRef.current = null;
    }
    setShowModal(false);
  };

  const cancel = () => {
    nextArgsRef.current = null;
    setShowModal(false);
  };

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;
    originalPushRef.current = originalPush;

    navigator.push = (...args) => {
      nextArgsRef.current = args;
      setShowModal(true);
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [when, navigator]);

  return { showModal, message, proceed, cancel };
}
